<template>
  <div id="app">
    <section id="home">
      <Home />
    </section>

    <section id="features">
      <Features />
    </section>

     <section id="testimonials">
      <UserTestimonial />
    </section>
    

    <section id="pricing">
      <Pricing />
    </section>

    <section id="partners">
      <Partners />
    </section>

    <section id="contact">
      <Contact />
    </section>
    </div>
</template>

<script>
import Home from '@/components/Home.vue';
import Features from '@/components/Features.vue';
import Pricing from '@/components/Pricing.vue';
import Partners from '@/components/Partners.vue';
import Contact from '@/components/Contact.vue';
import UserTestimonial from '@/components/UserTestimonial.vue';

export default {
  name: "HomePageView",
  components: {   Home, Features,UserTestimonial, Pricing, Partners,Contact }
};
</script>

<style>
html {
  scroll-behavior: smooth;
}
body {
  margin: 0;
  font-family: Arial, sans-serif;
}
.navbar {
  display: flex;
  justify-content: space-between;
  background: #206A98;
  padding: 20px 30px;
  color: white;
}
.navbar .logo {
  display: flex;
  align-items: center;
}
.navbar ul {
  list-style: none;
  display: flex;
  gap: 30px;
}
.navbar a {
  color: white;
  text-decoration: none;
}
.navbar a:hover {
  text-decoration: underline;
}
main {
  padding: 20px;
}
footer {
  text-align: center;
  background: #206A98;
  color: white;
  padding: 10px;
  margin-top: 20px;
}
section {
  padding: 0px 10px;
}
</style>



